import { createRouter, createWebHistory } from "vue-router";
import HomePage from "../views/homePage.vue";
import ProvinceContent from "../views/provinceContent.vue";
import NewsList from "../views/newsList.vue";
import ArcticleDetail from "../views/articleDetail.vue";
import AboutUs from "../views/aboutUs.vue";
import KeyList from "../views/keyList.vue";
import ServiceGuide from "../views/serviceGuide/serviceGuide.vue";
import GeoDataSecurityCheck from "../views/geoDataSecurityCheck.vue";
import Cehuishi from "../views/cehuishi.vue";
const routes = [
  {
    path: "/",
    name: "home",
    component: HomePage,
  },
  { path: "/detail/bj", component: ProvinceContent },
  { path: "/detail/tj", component: ProvinceContent },
  { path: "/detail/heb", component: ProvinceContent },
  { path: "/detail/sx", component: ProvinceContent },
  { path: "/detail/nm", component: ProvinceContent },
  { path: "/detail/ln", component: ProvinceContent },
  { path: "/detail/jl", component: ProvinceContent },
  { path: "/detail/hl", component: ProvinceContent },
  { path: "/detail/sh", component: ProvinceContent },
  { path: "/detail/js", component: ProvinceContent },
  { path: "/detail/zj", component: ProvinceContent },
  { path: "/detail/ah", component: ProvinceContent },
  { path: "/detail/fj", component: ProvinceContent },
  { path: "/detail/jx", component: ProvinceContent },
  { path: "/detail/sd", component: ProvinceContent },
  { path: "/detail/hen", component: ProvinceContent },
  { path: "/detail/hb", component: ProvinceContent },
  { path: "/detail/hn", component: ProvinceContent },
  { path: "/detail/gd", component: ProvinceContent },
  { path: "/detail/gx", component: ProvinceContent },
  { path: "/detail/hi", component: ProvinceContent },
  { path: "/detail/cq", component: ProvinceContent },
  { path: "/detail/sc", component: ProvinceContent },
  { path: "/detail/gz", component: ProvinceContent },
  { path: "/detail/yn", component: ProvinceContent },
  { path: "/detail/xz", component: ProvinceContent },
  { path: "/detail/sn", component: ProvinceContent },
  { path: "/detail/gs", component: ProvinceContent },
  { path: "/detail/qh", component: ProvinceContent },
  { path: "/detail/nx", component: ProvinceContent },
  { path: "/detail/xj", component: ProvinceContent },
  { path: "/detail/xjscjsbt", component: ProvinceContent },
  {
    path: "/news",
    name: "news",
    component: NewsList,
  },
  {
    path: "/article",
    name: "article",
    component: ArcticleDetail,
  },
  {
    path: "/aboutUs",
    name: "aboutUs",
    component: AboutUs,
  },
  {
    path: "/keyList",
    name: "keyList",
    component: KeyList,
  },
  {
    path: "/serviceGuide",
    name: "serviceGuide",
    component: ServiceGuide,
  },
  {
    path: "/geoDataSecurityCheck",
    name: "geoDataSecurityCheck",
    component: GeoDataSecurityCheck,
  },
  {
    path: "/cehuishi",
    name: "cehuishi",
    component: Cehuishi,
  },
  {
    path: "/:path(.*)",
    component: HomePage,
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
